export default "__VITE_ASSET__44aa0ed4__"